import BaseTable from './base-table.vue'

export default BaseTable